<template>
  <div>
    <!-- tabbar -->
    <el-tabs
      ref="tabs"
      :stretch="stretch"
      v-model="propsTabsValue"
      :type="type"
      :closable="closable"
      :tab-position="tabPosition"
      @tab-click="handleTabClick"
    >
      <el-tab-pane
        v-for="item in tabPaneData"
        :key="item.id"
        :label="item.label"
        :name="item.id"
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  props: {
    // 标签的宽度是否自撑开
    stretch: {
      type: Boolean,
      default: false,
    },
    // 绑定值，选中选项卡的 name
    tabsValue: {
      type: String,
      default: "",
    },
    // 风格类型
    type: {
      type: String,
      default: "card",
    },
    // 标签是否可关闭
    closable: {
      type: Boolean,
      default: false,
    },
    // 选项卡所在位置
    tabPosition: {
      type: String,
      default: "top",
    },
    tabPaneData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      propsTabsValue: this.tabsValue,
    };
  },
  mounted() {},
  watch: {
    tabsValue: {
      immediate: true,
      handler: function (newVal) {
        this.propsTabsValue = newVal;
      },
    },
  },
  methods: {
    // tab 被选中时触发
    handleTabClick(row) {
      this.$emit("tabClick", row);
    },
  },
};
</script>

<style lang="scss" scoped>
/* ::v-deep .el-tabs {
  margin: 0 0 30px;
} */

::v-deep .el-table {
  min-height: 300px;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-top: 2px #2587ff solid !important;
  background: #f4f7ff !important;
  line-height: 48px;
  color: #2587ff !important;
}

::v-deep .el-tabs__header {
  margin: 0;
}

::v-deep .el-tabs__nav-wrap.is-scrollable {
  padding: 0;
}

::v-deep .el-tabs__item {
  border-top: 2px #fff solid;
  line-height: 48px;
  height: 48px;
  color: #333333 !important;
}
</style>
